import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';
import { Box, Typography } from '@mui/material';
import { InvitedUserItem, InvitedUsersResponse, InvitedUsersTableData, InvitedUserTableRowActions } from './interfaces';
import HelpInfoWrapper from '../../../../../common/help-info-wrapper';

export const mapApiDataIntoTableFormat = (
  data: InvitedUsersResponse,
  actionsHandling: InvitedUserTableRowActions
): InvitedUsersTableData[] =>
  data.invitations.map((invitedUserItem: InvitedUserItem) => {
    const { invitationId, invitationStatus, emailAddress, invitationDate, expirationDate, role } = invitedUserItem;
    const actions = [
      {
        name: TABLE_ACTION.RETRY,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actionsHandling.openResend(invitedUserItem, data.settings.availableRoles);
        }
      },
      {
        name: TABLE_ACTION.DELETE,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actionsHandling.openDelete(invitedUserItem);
        }
      }
    ];
    return {
      id: invitationId,
      status: invitationStatus,
      emailAddress,
      role: (
        <Box display="flex" justifyContent="space-between">
          <HelpInfoWrapper tooltip={role.description} tooltipPlacement="bottom">
            <Typography>{role.name}</Typography>
          </HelpInfoWrapper>
        </Box>
      ),
      invitationDate,
      expirationDate,
      actions: <ActionsColumn actions={actions} />
    };
  });
